import { mscHost } from 'config/env.conf';
let protocol = window.location.protocol;
export const getMscSrc = function(src) {
    return `${mscHost}/msc/biz/login?continue=${encodeURIComponent(src.includes('://')?src:protocol+src)}`;
}


// WEBPACK FOOTER //
// ./src/router/routerHelper.js